import { render, staticRenderFns } from "./UtilTabs.vue?vue&type=template&id=196bbcc2&scoped=true"
import script from "./UtilTabs.vue?vue&type=script&lang=js"
export * from "./UtilTabs.vue?vue&type=script&lang=js"
import style0 from "./UtilTabs.vue?vue&type=style&index=0&id=196bbcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196bbcc2",
  null
  
)

export default component.exports